var render = function render(){
  var _vm$event, _vm$eventFlow;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    staticClass: "w-100",
    attrs: {
      "show": _vm.loading,
      "spinner-variant": "primary",
      "spinner-type": "grow"
    }
  }, [_c('div', {
    staticClass: "event-flow"
  }, [_c('div', {
    staticClass: "the-sticky"
  }, [_c('event-flow-form', {
    attrs: {
      "event-id": (_vm$event = _vm.event) === null || _vm$event === void 0 ? void 0 : _vm$event.id,
      "filter-data": _vm.filterFormData,
      "extra-data": _vm.extraFunctionFormData,
      "responsibles": _vm.getResponsibles,
      "locations": _vm.getLocations,
      "topics": _vm.getTopics,
      "event-flow-selected": _vm.eventFlowSelected
    },
    on: {
      "update:filterData": function ($event) {
        _vm.filterFormData = $event;
      },
      "update:filter-data": function ($event) {
        _vm.filterFormData = $event;
      },
      "update:extraData": function ($event) {
        _vm.extraFunctionFormData = $event;
      },
      "update:extra-data": function ($event) {
        _vm.extraFunctionFormData = $event;
      },
      "update:eventFlowSelected": function ($event) {
        _vm.eventFlowSelected = $event;
      },
      "update:event-flow-selected": function ($event) {
        _vm.eventFlowSelected = $event;
      },
      "search-changed": function ($event) {
        return _vm.fetch(_vm.formData.startDateTime, _vm.formData.endDateTime);
      }
    },
    model: {
      value: _vm.formData,
      callback: function ($$v) {
        _vm.formData = $$v;
      },
      expression: "formData"
    }
  }), _vm.eventFlowSelected ? _c('event-flow-location-header', {
    attrs: {
      "event-flow-locations": (_vm$eventFlow = _vm.eventFlow) === null || _vm$eventFlow === void 0 ? void 0 : _vm$eventFlow.eventFlowLocations,
      "extra-function-form-data": _vm.extraFunctionFormData
    }
  }) : _vm._e()], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.eventFlowSelected,
      expression: "!eventFlowSelected"
    }]
  }, [_c('event-flow-table', {
    attrs: {
      "start-date-time": _vm.formData.startDateTime,
      "end-date-time": _vm.formData.endDateTime,
      "event-flow-items": _vm.localEventFlowItems
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.eventFlowSelected,
      expression: "eventFlowSelected"
    }]
  }, [_c('event-flow-grid', {
    attrs: {
      "step": _vm.formData.step,
      "extra-data": _vm.extraFunctionFormData,
      "start-date-time": _vm.formData.startDateTime,
      "end-date-time": _vm.formData.endDateTime,
      "event-flow-items": _vm.localEventFlowItems,
      "responsibles": _vm.getResponsibles
    },
    on: {
      "update": _vm.update,
      "create": _vm.onCreate,
      "click": _vm.click
    }
  })], 1)]), _c('custom-modal', {
    attrs: {
      "id": "event-item-modal",
      "title": _vm.selectedItem.id ? _vm.$t('event-flow.popup.title-edit') : _vm.$t('event-flow.popup.title-new'),
      "size": "xl"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function () {
        return [_c('event-item-modal', {
          attrs: {
            "item": _vm.selectedItem,
            "max-date-time": _vm.event.selectedEndDate
          },
          on: {
            "success": _vm.success
          }
        })];
      },
      proxy: true
    }])
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.eventFlowSelected,
      expression: "eventFlowSelected"
    }],
    staticClass: "add-item-button"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.onCreate
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "plus",
      "size": "sm"
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }